// frontend/src/services/photo.service.ts
import api from './api';
import { Photo } from '../types';

class PhotoService {
  async getCouplePhotos(coupleId: string, featured?: boolean): Promise<Photo[]> {
    try {
      let url = `/weddings/photos/couple/${coupleId}`;
      if (featured !== undefined) {
        url += `?featured=${featured}`;
      }
      const response = await api.get<Photo[]>(url);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getPhoto(id: string): Promise<Photo> {
    try {
      const response = await api.get<Photo>(`/weddings/photos/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createPhoto(photoData: {
    url: string;
    title?: string;
    caption?: string;
    featured?: boolean;
    couple: string;
    uploaderName?: string;
    uploaderEmail?: string;
  }): Promise<Photo> {
    try {
      const response = await api.post<Photo>('/weddings/photos', photoData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updatePhoto(id: string, photoData: Partial<Photo>): Promise<Photo> {
    try {
      const response = await api.patch<Photo>(`/weddings/photos/${id}`, photoData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deletePhoto(id: string): Promise<void> {
    try {
      await api.delete(`/weddings/photos/${id}`);
    } catch (error) {
      throw this.handleError(error);
    }
  }

  private handleError(error: any): Error {
    if (error.response && error.response.data && error.response.data.message) {
      const message = Array.isArray(error.response.data.message)
        ? error.response.data.message.join(', ')
        : error.response.data.message;
      return new Error(message);
    }
    return error instanceof Error ? error : new Error('An unexpected error occurred');
  }
}

export default new PhotoService();